import "core-js/modules/es6.regexp.match";
var _this = this;
import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import store from '@/store';
import { getAccessToken } from '@/utils/auth';

// create an axios instance
var service = axios.create({
  baseURL: '',
  // url = base url + request url
  withCredentials: true,
  // send cookies when cross-domain requests
  timeout: 100000 // request timeout
});

// request interceptor
service.interceptors.request.use(function (config) {
  console.log(config);
  if (store.getters.token) {
    config.headers['Authorization'] = getAccessToken();
  }
  return config;
}, function (error) {
  console.log(error); // for debug
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
 */

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  console.log(response);
  var res = response.data;
  // if the custom code is not 20000, it is judged as an error.
  if (res.code !== 0) {
    var _res$data;
    if (res.code === 401 || ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 401) {
      MessageBox.confirm('当前登录已过期，是否重新登录？', '提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.$router.push("/login?redirect=".concat(_this.$route.fullPath));
      });
      store.dispatch('user/logout');
      return;
    }
    if (!response.config.url.match('/query/pre') && !response.config.url.match('/query/after')) {
      Message({
        message: res.message || res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      });
    }

    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      // to re-login
      MessageBox.confirm('您已退出登录，可以再次登录', '确认登录', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        store.dispatch('user/resetToken').then(function () {
          location.reload();
        });
      });
    }
    return Promise.reject(new Error(res.message || 'Error'));
  } else {
    return res;
  }
}, function (error) {
  console.log('err' + error); // for debug
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
  return Promise.reject(error);
});
export default service;